/// <amd-module name="TFS/Admin/OrganizationAadControls/Components/AadActionUnsuccessDialog" />
import React = require("react");
import AdminResources = require("TFS/Admin/OrganizationAadControls/Resources");
import { Dialog } from "VSSUI/Dialog";
import { format } from "VSS/Core/Util/String";
import { createMarkup } from "TFS/Admin/Common/Util/HtmlString";
import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";
import { filterXSS } from "xss";
import { VssComponent } from "VSS/Platform/Layout";
import { IAadActionUnsuccessDialogComponentProps } from "TFS/Admin/OrganizationAadCommon/Contracts/DialogControls.props";

export class AadActionUnsuccessDialogComponent extends React.Component<IAadActionUnsuccessDialogComponentProps> {
    public render(): JSX.Element {
        return (
            <Dialog
                calloutContentClassName="action-unsuccess-dialog"
                footerButtonProps={[
                    {
                        onClick: () => this.props.onClose(),
                        text: AdminResources.Close
                    }
                ]}
                onDismiss={() => this.props.onClose()}
                titleProps={{
                    text: this.props.isConnectAction === true ? AdminResources.AadConnectionFailTitle : AdminResources.AadDisconnectionFailTitle
                }}
            >
                {this._renderDialogBody()}
            </Dialog>
        );
    }

    private _renderDialogBody(): JSX.Element {
        return (
            <div className="block-display">
                <p>
                    <span
                        className="aad-action-failure-description"
                        dangerouslySetInnerHTML={createMarkup(
                            format(
                                this.props.isConnectAction === true
                                    ? AdminResources.AadConnectionFailDescription
                                    : AdminResources.AadDisconnectionFailDescription,
                                filterXSS(this.props.orgName),
                                filterXSS(this.props.orgTenantName)
                            )
                        )}
                    />
                </p>
                <MessageBar severity={MessageBarSeverity.Error}>
                    <div className="block-display">{this.props.error}</div>
                </MessageBar>
            </div>
        );
    }
}

VssComponent.register("ms.vss-admin-web.aad-action-unsuccess-dialog", AadActionUnsuccessDialogComponent);
